import React, { useState } from "react";
import { Tabs, Tab, Box, Typography, FormControlLabel, Checkbox, Paper, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    root: {
        width: "100%",
        padding: "16px",
    },
    tabContainer: {
        borderBottom: "1px solid #ddd",
    },
    reviewOptionsContainer: {
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "#ffffff",
        borderRadius: "12px",
    },
    checkboxContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
    },
    questionContainer: {
        padding: "24px",
        backgroundColor: "#F6F8FB",
        borderRadius: "12px",
        textAlign: "left",
    },
    marksBox: {
        display: "inline-block",
        backgroundColor: "#d4e8d2",
        color: "#2d672d",
        padding: "4px 12px",
        borderRadius: "8px",
        fontWeight: "bold",
        marginTop: "8px",
    },
});

const reviewOptions = [
    "The attempt",
    "Marks",
    "Specific feedback",
    "General feedback",
    "Right answer",
    "Overall feedback",
];

const ReviewOptions: React.FC = () => {
    const classes = useStyles();
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    return (
        <Box className={classes.root}>
            {/* Tabs for review options */}
            <Tabs value={activeTab} onChange={handleTabChange} className={classes.tabContainer}>
                <Tab label="During the attempt" />
                <Tab label="Immediately after attempt" />
                <Tab label="Later (quiz open)" />
                <Tab label="Quiz closed" />
            </Tabs>

            {/* Grid Layout for Content */}
            <Grid container spacing={2} sx={{ mt: 2 }}>
                {/* Left Section - Review Options */}
                <Grid item xs={12} md={4}>
                    <Box className={classes.reviewOptionsContainer}>
                        <Typography variant="h6" sx={{ mb: 1 }}>
                            Review Options
                        </Typography>
                        <Box className={classes.checkboxContainer}>
                            {reviewOptions.map((option) => (
                                <FormControlLabel
                                    key={option}
                                    control={<Checkbox />}
                                    label={option}
                                />
                            ))}
                        </Box>
                    </Box>
                </Grid>

                {/* Right Section - Question Preview */}
                <Grid item xs={12} md={8}>
                    <Box className={classes.reviewOptionsContainer}>
                        <Box className={classes.questionContainer}>
                            <Grid container>
                                <Grid item xs={10} md={8}>
                                    <Typography variant="body1" fontWeight="bold">
                                        Q. The question of the assessment comes here
                                    </Typography>
                                    <Typography>a) Option 1</Typography>
                                    <Typography>b) Option 2</Typography>
                                    <Typography>c) Option 3</Typography>
                                    <Typography>c) Option 3</Typography>

                                    <Typography sx={{ mt: 2, fontWeight: "bold" }}>
                                        A. The answer to the given question here.
                                    </Typography>
                                </Grid>
                                <Grid item xs={2} md={4}>
                                    <Box className={classes.marksBox}>1 marks</Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ReviewOptions;
